import { useState } from "react";
import EditableSlider from "./EditableSlider";
import ReadOnlySlider from "./ReadOnlySlider";

function ImportancyRange({ item, isEditing, onValuesChange }) {
  const [values, setValues] = useState({
    leadtime_level: item.leadtime_level || 1,
    schedule_adherence: item.schedule_adherence || 1,
    duedate_compliance: item.duedate_compliance || 1,
    order_priority: item.order_priority || 1,
  });
  const handleChange = (field) => (event, newValue) => {
    const updatedValues = {
      ...values,
      [field]: newValue,
    };
    setValues(updatedValues);
    onValuesChange && onValuesChange(updatedValues);
  };
  const selection =
    item.learning_direction === 0
      ? "Backward"
      : item.learning_direction === 1
      ? "Forward"
      : "Back + Forward";
  if (isEditing) {
    return (
      <>
        <EditableSlider
          label="리드타임"
          value={values.leadtime_level}
          selection={selection}
          onChange={handleChange("leadtime_level")}
        />
        <EditableSlider
          label="전체일정"
          value={values.schedule_adherence}
          selection={selection}
          onChange={handleChange("schedule_adherence")}
        />
        <EditableSlider
          label="납기준수"
          value={values.duedate_compliance}
          selection={selection}
          onChange={handleChange("duedate_compliance")}
        />
        <EditableSlider
          label="주문 우선순위"
          value={values.order_priority}
          selection={selection}
          onChange={handleChange("order_priority")}
        />
      </>
    );
  }
  return (
    <>
      <ReadOnlySlider
        label="리드타임"
        value={item.leadtime_level || 1}
        selection={selection}
      />
      <ReadOnlySlider
        label="전체일정"
        value={item.schedule_adherence || 1}
        selection={selection}
      />
      <ReadOnlySlider
        label="납기준수"
        value={item.duedate_compliance || 1}
        selection={selection}
      />
      <ReadOnlySlider
        label="주문 우선순위"
        value={item.order_priority || 1}
        selection={selection}
      />
    </>
  );
}

export default ImportancyRange;
